// src/helpers/factories/menuSpecialCardFactory.ts
var menuSpecialCardFactory = (specials) => {
  return Object.values(specials).map((special) => {
    var _a, _b;
    return {
      id: special.specialId,
      title: special.name,
      locationsCount: (_b = (_a = special.locationIds) == null ? void 0 : _a.length) != null ? _b : 0,
      locationIds: special.locationIds || []
    };
  });
};
var dropdownAllLocationOptionFactory = (locations) => locations.map((location) => ({
  label: location.streetLine1,
  value: location.id
}));

export { dropdownAllLocationOptionFactory, menuSpecialCardFactory };
